/* Plugins ------------------------------------------------------------------
Author: Nathan Walsh <nwalsh@awareweb.com>
Date: October 9, 2014
-------------------------------------------------------------------*/
/* =============================================================
* thd.forms.js v.2.6 - edited
===============================================================*/

//thdforms namespace to keep everybody kosher
var thdForms = thdForms || {};
//Creates custom Checkbox controls
thdForms.checkBoxes = {
    init: function (thdFormSelecter) {

        // This intially sets the custom selectboxes on doc ready
        $(thdFormSelecter).each(function () {
            var $cb = $(this),
                theParent = $cb.parent();

            $cb.addClass('checkbox-hidden');

            //if any disabled and not checked
            if ($cb.is(':disabled') && !($cb.is(':checked'))) {
                //$cb.next().prepend(function () {
                $cb.after(function () {
                    return '<div class="checkbox-custom checkbox-custom-disabled"><i class="fa fa-check"></i></div>';
                });

                //if any disabled and checked
            } else if ($cb.is(':disabled') && $cb.is(':checked')) {
                //$cb.next().prepend(function () {
                $cb.after(function () {
                    return '<div class="checkbox-custom checkbox-custom-disabled-checked"><i class="fa fa-check"></i></div>';
                });

            } else {
                //$cb.next().prepend(function () {
                $cb.after(function () {
                    return ($cb.is(':checked')) ? '<div class="checkbox-custom checkbox-custom-active"><i class="fa fa-check"></i></div>' : '<div class="checkbox-custom"><i class="fa fa-check"></i></div>';
                });
            }

            if (theParent.hasClass("parent")) {
                if (theParent.find('input[type="checkbox"]:checked').length > 0) {
                    theParent.removeClass("trans");
                }
            }
        });

        $(document.body).delegate("label.checkbox", "click", function (e) {
            //e.preventDefault();
        });

        //when a selectbox's state has changed...
        $(thdFormSelecter).change(function (e) {
            var $this = $(this),
                checked = $this.prop("checked"),
                container = $this.parent();

            //controls the select and deselect all when parent is clicked
            container.find('input[type="checkbox"]').prop({ indeterminate: false, checked: checked });



            //this function runs a check to see who is :checked, who is the parent, and which state to change whom to
            function checkSiblings(el) {
                var parent = el.parent().parent(),
                    all = true,
                    parentCheckbox = parent.children('input[type="checkbox"]').first(),
                    parentCheckboxParent = el.parent().children("li.parent"),
					cb = parentCheckbox.next().children("div.checkbox-custom"),
                    areAllChecked = parent.find('input[type="checkbox"]:checked').length > 0,
                    isIntermediate = parentCheckbox.prop({ indeterminate: true }).length > 0,
                    //$cbs = parent.children().find('input[type="checkbox"]').next().children("div.checkbox-custom"),
					$cbs = parent.children().find('input[type="checkbox"]').parent().children("div.checkbox-custom"),
                    removeTrans = function () {
                        el.parent().parent().removeClass("trans");
                    };

                //runs through each checkbox to see if it has been checked; then sets the value of 'all' depending on the result
                el.siblings().each(function () {
                    return all = ($(this).children('input[type="checkbox"]').prop("checked") === checked) ? true : false;
                });

                //now the fun part...
                if (all && checked) {
                    parentCheckbox.prop({ indeterminate: false, checked: true });
                    cb.addClass('checkbox-custom-active');
                    $cbs.addClass('checkbox-custom-active');
                    removeTrans();
                    el.removeClass("trans");
                    //console.log("all=true checked=true or everybody is unchecked");

                } else if (all && !checked) {
                    if (areAllChecked) {
                        parentCheckbox.prop({ indeterminate: areAllChecked, checked: false });
                        cb.removeClass('checkbox-custom-indeterminate checkbox-custom-active');
                        $cbs.removeClass('checkbox-custom-active');
                        el.parent().parent().addClass("trans");
                        //console.log("all=true checked=false areallChecked=true");

                    } else {
                        parentCheckbox.prop({ indeterminate: areAllChecked });
                        cb.removeClass('checkbox-custom-indeterminate');
                        $cbs.removeClass('checkbox-custom-active checkbox-custom-indeterminate');
                        parentCheckboxParent.addClass("trans");
                        parent.addClass("trans");
                        $("div.controls").removeClass("trans");
                        //console.log("all=true checked=false areallChecked=false");
                    }

                } else {
                    if (isIntermediate) {
                        parentCheckbox.prop({ indeterminate: true, checked: false });
                        cb.addClass('checkbox-custom-indeterminate').removeClass('checkbox-custom-active');
                        removeTrans();
                        //console.log("all=false checked=true isIntermediate=true");

                    } else {
                        parentCheckbox.prop({ indeterminate: false, checked: true });
                        cb.removeClass('checkbox-custom-indeterminate').addClass('checkbox-custom-active');
                        removeTrans();
                        //console.log("all=false checked=true isIntermediate=false");  
                    }

                    //all purpose toggle for everybody, including those not in a intermeidate cb group.
                    $this.next().children("div.checkbox-custom").toggleClass('checkbox-custom-active');
                    //container.children("div.checkbox-custom").toggleClass('checkbox-custom-active');
                }
            }
            checkSiblings(container);
        });
    }
}
//Creates custom radio button and slider controls
thdForms.radioButtons = {
    init: function (thdFormSelecter) {
        var $form = thdFormSelecter.parent().parent(".slider-group");

        $(thdFormSelecter).each(function (i) {
            //If slider class, builds out the on/off slider radio buttons
            if ($(this).hasClass("slider")) {
                var $formSlider = $form.find(".slider-control"),
                    $theSlider = $(this),
                    theSliderAttr = $theSlider.attr("alt"),
                    slideMe,
                    slideIt = {
                        switcher: function (inputAttr, labelInput) {
                            var slideMe = labelInput;
                            //if 'On' is clicked, turn OFF the control
                            if (inputAttr === "on") {
                                slideForward(slideMe);
                                labelInput.siblings("input[alt='off']").prop("checked", true);
                            }
                            //if 'Off' is clicked, turn ON the control
                            if (inputAttr === "off") {
                                slideBackward(slideMe);
                                labelInput.siblings("input[alt='on']").prop("checked", true);
                            }
                        }
                    };

                //Check the slider settings when the page is loaded
                if ($theSlider.is(":checked")) {
                    //if On is already checked
                    if (theSliderAttr === "on") {
                        slideMe = $theSlider
                        slideBackward(slideMe);
                    }
                    //if Off is already checked
                    if (theSliderAttr === "off") {
                        slideMe = $theSlider;
                        slideForward(slideMe);
                    }
                }

                //for when the slider label is clicked
                $theSlider.click(function (e) {
                    var theLabel = $(e.target).next();

                    if (theLabel.is("label")) {
                        var labelInput = theLabel.prev(),
                            inputAttr = labelInput.attr("alt");

                        slideIt.switcher(inputAttr, labelInput);
                    }
                });

                //Otherwise, this builds out the default custom radio buttons
                //Changed to place the custom radio button directly after the input - Nathan Walsh 9/23/14
            } else {
                var $cbRadio = $(this);
                $cbRadio.addClass('radio-hidden');
                if ($cbRadio.is(':disabled') && !($cbRadio.is(':checked'))) {
                    //$cbRadio.next().prepend(function () {
                    $cbRadio.after(function () {
                        return '<div class="radio-custom radio-custom-disabled"><div class="radio-inner"></div></div>';
                    });
                } else if ($cbRadio.is(':disabled') && $cbRadio.is(':checked')) {
                    //$cbRadio.next().prepend(function () {
                    $cbRadio.after(function () {
                        return '<div class="radio-custom radio-custom-disabled-checked"><div class="radio-inner"></div></div>';
                    });

                } else {
                    //$cbRadio.next().prepend(function () {
                    $cbRadio.after(function() {
                        if ($cbRadio.parent().find('.radio-custom').length == 0)
                            return ($cbRadio.is(':checked'))
                                ? '<div class="radio-custom radio-custom-active"><div class="radio-inner"></div></div>'
                                : '<div class="radio-custom"><div class="radio-inner"></div></div>';
                        else {
                            $cbRadio.parent().find('.radio-custom').remove();
                            return ($cbRadio.is(':checked'))
                                ? '<div class="radio-custom radio-custom-active"><div class="radio-inner"></div></div>'
                                : '<div class="radio-custom"><div class="radio-inner"></div></div>';
                        }
                    });
                }
                // and finally bind the click event to update the new radio control's state graphics
                $cbRadio.click(function () {
                    $('div.radio-custom').removeClass('radio-custom-active');
                    $cbRadio.next().first().toggleClass('radio-custom-active');
                });
            }
        }); //end each loop

        //attaches click event to switch butons on the page
        $form.delegate("span.switch-button", "click", function (e) {
            var $whosChecked = $(this).siblings(":checked"),
                inputAttr = $whosChecked.attr("alt");

            if (inputAttr === "on") {
                slideForward($whosChecked);
                $whosChecked.siblings("input[alt='off']").prop("checked", true);
            }

            if (inputAttr === "off") {
                slideBackward($whosChecked);
                $whosChecked.siblings("input[alt='on']").prop("checked", true);
            }
        });

        //slide the button forward
        function slideForward(slideMe) {
            slideMe.siblings("span.switch-button").addClass("slideUp");
            slideMe.parent().addClass("slider-control-off");
        }
        //slide the button backward
        function slideBackward(slideMe) {
            slideMe.siblings("span.switch-button").removeClass("slideUp");
            slideMe.parent().removeClass("slider-control-off");
        }
    }
}


$(function () {
    var thdFormSelecter1 = $("input[type=checkbox]"),
        thdFormSelecter2 = $("input[type=radio]"),
        thdFormSelecter3 = $("form"),
        $bodyDelegate = $(document.body);

    thdForms.checkBoxes.init(thdFormSelecter1);
    thdForms.radioButtons.init(thdFormSelecter2);

});


/*
popModal - 1.06 [20.08.14]
Author: vadimsva
Github: https://github.com/vadimsva/popModal
*/
(function (a) {
    a.fn.popModal = function (c) {
        function h() {
            function c(a) {
                var b = Math.max(A, B, C); return (a == r ? 0 < B : a == u ? 0 < A : 0 < C) ? a : 0 < B && B == b ? r : 0 < A && A == b ? u : 0 < C && C == b ? D : a;
            } if (l.inline) var g = d.position().left, f = d.position().top; else g = d.offset().left, f = d.offset().top; var h = parseInt(d.css("marginLeft")); parseInt(d.css("paddingLeft")); var k = parseInt(d.css("marginTop")), m = d.outerHeight(), n = d.outerWidth(), p = parseInt(b.css("maxWidth")), s = parseInt(b.css("minWidth")), v = b.outerHeight(); q ? isNaN(p) && (p = 300) : (isNaN(s) && (s =
            180), p = s); b.css({ width: p + "px" }); var z, x = d.offset().left, w = a(window).width() - d.offset().left - n, H = d.offset().top, s = x - 10 - p, A = n + x - p, I = w - 10 - p, B = n + w - p, C = Math.min(n / 2 + w - p / 2, n / 2 + x - p / 2), x = H - v / 2; /^bottom/.test(l.placement) ? z = c(l.placement) : /^left/.test(l.placement) ? z = 0 < s ? l.placement == E && 0 < x ? E : y : c(r) : /^right/.test(l.placement) && (z = 0 < I ? l.placement == F && 0 < x ? F : G : c(u)); b.removeAttr("class").addClass(e + " animated " + z); switch (z) {
                case r: b.css({ top: f + k + m + 10 + "px", left: g + h + "px" }).addClass(t + "Bottom"); break; case u: b.css({
                    top: f +
                    k + m + 10 + "px", left: g + h + n - p + "px"
                }).addClass(t + "Bottom"); break; case D: b.css({ top: f + k + m + 10 + "px", left: g + h + (n - p) / 2 + "px" }).addClass(t + "Bottom"); break; case y: b.css({ top: f + k + "px", left: g + h - p - 10 + "px" }).addClass(t + "Left"); break; case G: b.css({ top: f + k + "px", left: g + h + n + 10 + "px" }).addClass(t + "Right"); break; case E: b.css({ top: f + k + m / 2 - v / 2 + "px", left: g + h - p - 10 + "px" }).addClass(t + "Left"); break; case F: b.css({ top: f + k + m / 2 - v / 2 + "px", left: g + h + n + 10 + "px" }).addClass(t + "Right");
            }
        } function k() {
            b = a("." + e); b.length && (f(), s || (s = b.css("animationDuration"),
            s = void 0 != s ? 1E3 * s.replace("s", "") : 0), setTimeout(function () {
                a("." + e + "_source").replaceWith(a("." + e + "_content").children()); b.remove(); a("html." + e + "Open").off("." + e + "Event").removeClass(e + "Open");
            }, s));
        } function f() {
            var a = b.attr("class"), e = a.replace(t, n); b.removeClass(a).addClass(e);
        } var d = a(this), b, g = "", q = !0, m = "", e = "popModal", p, l, s, t = "fadeIn", n = "fadeOut", r = "bottomLeft", D = "bottomCenter", u = "bottomRight", y = "leftTop", E = "leftCenter", G = "rightTop", F = "rightCenter", v, w = {
            init: function (c) {
                l = a.extend({
                    html: "", placement: r,
                    showCloseBut: !0, onDocumentClickClose: !0, overflowContent: !1, inline: !0, onOkBut: function () { return !0; }, onCancelBut: function () { }, onLoad: function () { }, onClose: function () { }
                }, c); if (0 != a("body").find("." + e).length && a("body").find("." + e).attr("data-popModal_ID") == d.attr("data-popModal_ID")) k(); else {
                    a("html." + e + "Open").off("." + e + "Event").removeClass(e + "Open"); a("." + e + "_source").replaceWith(a("." + e + "_content").children()); a("." + e).remove(); l.showCloseBut && (m = a('<button type="button" class="close">&times;</button>'));
                    "fixed" == d.css("position") && (g = "position:fixed;"); p = l.overflowContent ? e + "_contentOverflow" : ""; v = (new Date).getMilliseconds(); d.attr("data-popModal_ID", v); c = a('<div class="' + e + ' animated" style="' + g + '" data-popModal_ID="' + v + '"></div>'); var f = a('<div class="' + e + "_content " + p + '"></div>'); c.append(m, f); a.isFunction(l.html) ? (f.append("Please, waiting..."), l.html(function (d) {
                        f.empty().append(d); b = a("." + e); q = !0; h();
                    })) : ("object" == a.type(l.html) && l.html.after(a('<div class="popModal_source"></div>')), f.append(l.html));
                    l.inline ? d.after(c) : a("body").append(c); b = a("." + e); b.find("." + e + "_footer") && b.find("." + e + "_content").css({ marginBottom: b.find("." + e + "_footer").outerHeight() + "px" }); a.isFunction(l.html) || a.type(l.html); if (l.onLoad && a.isFunction(l.onLoad)) l.onLoad(); b.on("destroyed", function () { if (l.onClose && a.isFunction(l.onClose)) l.onClose(); }); q = !0; ("absolute" != d.parent().css("position") || "fixed" != d.parent().css("position")) && 270 > b.find("." + e + "_content").width() && 60 > b.find("." + e + "_content").height() && (q = !1); h(); if (l.onDocumentClickClose) a("html").on("click." +
                    e + "Event", function (c) {
                        a(this).addClass(e + "Open"); b.is(":hidden") && k(); var f = a(c.target); f.parents().andSelf().is("." + e) || f.parents().andSelf().is(d) || (c = parseInt(f.parents().filter(function () { return "auto" !== a(this).css("zIndex"); }).first().css("zIndex")), isNaN(c) && (c = 0), f = f.css("zIndex"), "auto" == f && (f = 0), c < f && (c = f), c <= b.css("zIndex") && k());
                    }); a(window).resize(function () { h(); }); b.find(".close").bind("click", function () { k(); }); b.find('[data-popModalBut="close"]').bind("click", function () { k(); }); b.find('[data-popModalBut="ok"]').bind("click",
                    function (b) {
                        var e; l.onOkBut && a.isFunction(l.onOkBut) && (e = l.onOkBut(b)); !1 !== e && k();
                    }); b.find('[data-popModalBut="cancel"]').bind("click", function () {
                        if (l.onCancelBut && a.isFunction(l.onCancelBut)) l.onCancelBut(); k();
                    }); a("html").on("keydown." + e + "Event", function (a) { 27 == a.keyCode && k(); });
                }
            }, hide: function () { k(); }
        }; if (w[c]) return w[c].apply(this, Array.prototype.slice.call(arguments, 1)); if ("object" === typeof c || !c) return w.init.apply(this, arguments);
    }; a("* [data-popModalBind]").bind("click", function () {
        var c = a(this).attr("data-popModalBind"),
        c = { html: a(c) }; void 0 != a(this).attr("data-placement") && (c.placement = a(this).attr("data-placement")); void 0 != a(this).attr("data-showCloseBut") && (c.showCloseBut = /^true$/i.test(a(this).attr("data-showCloseBut"))); void 0 != a(this).attr("data-inline") && (c.inline = /^true$/i.test(a(this).attr("data-inline"))); void 0 != a(this).attr("data-overflowContent") && (c.overflowContent = /^false$/i.test(a(this).attr("data-overflowContent"))); void 0 != a(this).attr("data-onDocumentClickClose") && (c.onDocumentClickClose = /^true$/i.test(a(this).attr("data-onDocumentClickClose")));
        a(this).popModal(c);
    }); a.event.special.destroyed = { remove: function (a) { a.handler && a.handler(); } };
})(jQuery);
(function (a) {
    a.fn.notifyModal = function (c) {
        function h() {
            var b = a("." + d); setTimeout(function () {
                b.removeClass("open"); setTimeout(function () {
                    b.remove(); -1 != g.duration && clearTimeout(notifDur);
                }, q);
            }, q);
        } var k = a(this), f, d = "notifyModal", b = "", g, q, m = {
            init: function (e) {
                g = a.extend({ duration: 2500, placement: "center", type: "notify", overlay: !0 }, e); g.overlay && (b = "overlay"); a("." + d).remove(); e = a('<div class="' + d + " " + g.placement + " " + b + " " + g.type + '"></div>'); var c = a('<div class="' + d + '_content"></div>'), l = a('<button type="button" class="close">&times;</button>');
                k = void 0 == k[0] ? k.selector : k[0].innerHTML; c.append(l, k); e.append(c); a("body").append(e); f = a("." + d); q || (q = f.css("transitionDuration"), q = void 0 != q ? 1E3 * q.replace("s", "") : 0); setTimeout(function () { f.addClass("open"); }, q); f.click(function () { h(); }); -1 != g.duration && (notifDur = setTimeout(h, g.duration));
            }, hide: function () { h(); }
        }; a("html").keydown(function (a) { 27 == a.keyCode && h(); }); if (m[c]) return m[c].apply(this, Array.prototype.slice.call(arguments, 1)); if ("object" === typeof c || !c) return m.init.apply(this, arguments);
    };
    a("* [data-notifyModalBind]").bind("click", function () {
        var c = a(this).attr("data-notifyModalBind"), h = {}; void 0 != a(this).attr("data-duration") && (h.duration = parseInt(a(this).attr("data-duration"))); void 0 != a(this).attr("data-placement") && (h.placement = a(this).attr("data-placement")); void 0 != a(this).attr("data-onTop") && (h.onTop = /^true$/i.test(a(this).attr("data-onTop"))); a(c).notifyModal(h);
    });
})(jQuery);
(function (a) {
    a.fn.hintModal = function (c) {
        var h = {
            init: function (c) {
                a(this).mouseenter(function () {
                    var c = a(this).find("> .hintModal_container"); c.addClass("animated fadeInBottom"); var d = a(this), b, g = d.outerWidth(); b = c.outerWidth(); var h = d.offset().left, k = a(window).width() - d.offset().left - g, c = g + h - b, e = g + k - b, g = Math.min(g / 2 + k - b / 2, g / 2 + h - b / 2); b = d.hasClass("bottomLeft") ? "bottomLeft" : d.hasClass("bottomCenter") ? "bottomCenter" : d.hasClass("bottomRight") ? "bottomRight" : "bottomLeft"; void 0 == d.data("placement") && d.data("placement",
                    b); b = d.data("placement"); h = Math.max(c, e, g); c = ("bottomLeft" == b ? 0 < e : "bottomRight" == b ? 0 < c : 0 < g) ? b : 0 < e && e == h ? "bottomLeft" : 0 < c && c == h ? "bottomRight" : 0 < g && g == h ? "bottomCenter" : b; d.removeAttr("class").addClass("hintModal " + c);
                }); a(this).mouseleave(function () { a(this).find("> .hintModal_container").removeClass("animated fadeInBottom"); });
            }
        }; if (h[c]) return h[c].apply(this, Array.prototype.slice.call(arguments, 1)); if ("object" === typeof c || !c) return h.init.apply(this, arguments);
    }; a(".hintModal").hintModal();
})(jQuery);
(function (a) {
    a.fn.dialogModal = function (c) {
        function h() {
            var c = a("." + b); setTimeout(function () {
                c.removeClass("open"); setTimeout(function () {
                    c.remove(); a("body").removeClass(b + "Open"); a("html." + b + "Open").off("." + b + "Event").removeClass(b + "Open"); c.find("." + g).off("click"); c.find("." + q).off("click");
                }, e);
            }, e);
        } var k = a(this), f, d, b = "dialogModal", g = "dialogPrev", q = "dialogNext", m, e, p = {
            init: function (c) {
                function p() {
                    var c = d.outerHeight(); a(window).height() > c + 80 ? d.css({ marginTop: (a(window).height() - c) / 2 + "px" }) : d.css({ marginTop: "221px" });
                    a("body").addClass(b + "Open"); setTimeout(function () { f.addClass("open"); }, e); t();
                } function t() {
                    f.find('[data-dialogModalBut="close"]').bind("click", function () { h(); }); f.find('[data-dialogModalBut="ok"]').bind("click", function (b) {
                        var c; m.onOkBut && a.isFunction(m.onOkBut) && (c = m.onOkBut(b)); !1 !== c && h();
                    }); f.find('[data-dialogModalBut="cancel"]').bind("click", function () {
                        if (m.onCancelBut && a.isFunction(m.onCancelBut)) m.onCancelBut(); h();
                    });
                } m = a.extend({
                    onOkBut: function () { return !0; }, onCancelBut: function () { }, onLoad: function () { },
                    onClose: function () { }
                }, c); a("html." + b + "Open").off("." + b + "Event").removeClass(b + "Open"); a("." + b + " ." + g + ", ." + b + " ." + q).off("click"); a("." + b).remove(); var n = 0, r = k.length - 1; dialogMain = a('<div class="' + b + '"></div>'); dialogContainer = a('<div class="' + b + '_container"></div>'); dialogCloseBut = a('<button type="button" class="close">&times;</button>'); dialogBody = a('<div class="' + b + '_body"></div>'); dialogMain.append(dialogContainer); dialogContainer.append(dialogCloseBut, dialogBody); dialogBody.append(k[n].innerHTML);
                0 < r && dialogContainer.prepend(a('<div class="' + g + ' notactive"></div><div class="' + q + '"></div>')); a("body").append(dialogMain); f = a("." + b); d = a("." + b + "_container"); e || (e = f.css("transitionDuration"), e = void 0 != e ? 1E3 * e.replace("s", "") : 0); if (m.onLoad && a.isFunction(m.onLoad)) m.onLoad(); f.on("destroyed", function () { if (m.onClose && a.isFunction(m.onClose)) m.onClose(); }); p(); f.find("." + g).bind("click", function () {
                    0 < n && (--n, n < r && f.find("." + q).removeClass("notactive"), 0 == n && f.find("." + g).addClass("notactive"), dialogBody.empty().append(k[n].innerHTML),
                    p());
                }); f.find("." + q).bind("click", function () { n < r && (++n, 0 < n && f.find("." + g).removeClass("notactive"), n == r && f.find("." + q).addClass("notactive"), dialogBody.empty().append(k[n].innerHTML), p()); }); f.find(".close").bind("click", function () { h(); }); a("html").on("keydown." + b + "Event", function (a) { 27 == a.keyCode ? h() : 37 == a.keyCode ? f.find("." + g).click() : 39 == a.keyCode && f.find("." + q).click(); });
            }, hide: function () { h(); }
        }; if (p[c]) return p[c].apply(this, Array.prototype.slice.call(arguments, 1)); if ("object" === typeof c || !c) return p.init.apply(this,
        arguments);
    }; a("* [data-dialogModalBind]").bind("click", function () {
        var c = a(this).attr("data-dialogModalBind"); a(c).dialogModal();
    }); a.event.special.destroyed = { remove: function (a) { a.handler && a.handler(); } };
})(jQuery);
(function (a) {
    a.fn.titleModal = function (c) {
        var h = {
            init: function (c) {
                function f() {
                    var a = b.attr("class"), c = a.replace(h, m); b.removeClass(a).addClass(c);
                } var d, b; c = a("*[data-titleModal]"); var g, h = "fadeIn", m = "fadeOut"; c.mouseenter(function () {
                    d = a(this); titleAttr = d.attr("title"); d.removeAttr("title"); d.attr("data-title", titleAttr); titleModal = a('<div class="titleModal animated"></div>'); b = a(".titleModal"); placement = d.attr("data-placement"); void 0 == placement && (placement = "bottom"); b && b.remove(); d.after(titleModal.append(titleAttr));
                    b = a(".titleModal"); var c = d.position().left, f = d.position().top, g = d.css("marginLeft"), k = d.css("marginTop"), m = d.css("marginBottom"), n = d.outerHeight(), r = d.outerWidth(), D = b.css("marginTop"), u = b.outerWidth(), y = b.outerHeight(); switch (placement) {
                        case "bottom": b.css({ marginTop: parseInt(D) - parseInt(m) + "px", left: c + parseInt(g) + (r - u) / 2 + "px" }).addClass(h + "Bottom"); break; case "top": b.css({ top: f + parseInt(k) - y + "px", left: c + parseInt(g) + (r - u) / 2 + "px" }).addClass("top " + h + "Top"); break; case "left": b.css({
                            top: f + parseInt(k) +
                            n / 2 - y / 2 + "px", left: c + parseInt(g) - u - 10 + "px"
                        }).addClass("left " + h + "Left"); break; case "right": b.css({ top: f + parseInt(k) + n / 2 - y / 2 + "px", left: c + parseInt(g) + r + 10 + "px" }).addClass("right " + h + "Right");
                    }
                }); c.mouseleave(function () {
                    d = a(this); titleAttr = d.attr("data-title"); d.removeAttr("data-title"); d.attr("title", titleAttr); f(); g || (g = b.css("animationDuration"), g = void 0 != g ? 1E3 * g.replace("s", "") : 0); setTimeout(function () { b.remove(); }, g);
                });
            }
        }; if (h[c]) return h[c].apply(this, Array.prototype.slice.call(arguments, 1)); if ("object" ===
        typeof c || !c) return h.init.apply(this, arguments);
    }();
})(jQuery);